import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=db3062a0&scoped=true&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=db3062a0&lang=scss&"
import style1 from "./ResetPassword.vue?vue&type=style&index=1&id=db3062a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3062a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/333QLK_FE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db3062a0')) {
      api.createRecord('db3062a0', component.options)
    } else {
      api.reload('db3062a0', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=db3062a0&scoped=true&", function () {
      api.rerender('db3062a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resetPassword/components/ResetPassword.vue"
export default component.exports